import React from 'react';

type IconSlidingGateProps = {
  position?: number; // In percents from 0 to 100
};

export const IconSlidingGate: React.FC<IconSlidingGateProps> = ({ position = 100 }) => (
  <svg
    className="icon-cover icon-sliding-gate"
    width="46"
    height="25"
    viewBox="0 0 46 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {position > 90 && (
      <>
        <path
          d="M33.3871 22.3667L33.3871 1.51526L0.91758 1.51526L0.91758 22.3667"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.2651 11.9413L0.917759 11.9413M33.2651 17.4762L0.917759 17.4762M44.6826 22.4582L0.917759 22.4582M33.2651 6.49939L0.917759 6.49939"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.6129 1.51514L35.6129 21.9697"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.6133 1.51502L44.6827 22.4585"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    )}
    {position > 30 && position <= 90 && (
      <>
        <path
          d="M33.3871 22.3667L33.3871 1.51526L18 1.51526L18 22.3667"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.2651 11.9413L18 11.9413M33.2651 17.4762L18 17.4762M44.6826 22.4582L18 22.4582M33.2651 6.49939L18 6.49939"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.6129 1.51514L35.6129 21.9697"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.6133 1.51502L44.6827 22.4585"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    )}
    {position <= 30 && (
      <>
        <path
          d="M33.3871 22.3667L33.3871 1.51526L30.0001 1.51526L30.0001 22.3667"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.2651 11.9413H30M33.2651 17.4762H30M44.6826 22.4582H30M33.2651 6.49939H30"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.6129 1.51514L35.6129 21.9697"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.6133 1.51502L44.6827 22.4585"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    )}
  </svg>
);
